import {
  HHAlert,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { useParams } from 'react-router-dom';
import BillingLeftPanel from '../components/billing-tool-left-panel';
import BillingMainSection from '../components/billing-tool-main-section';
import LoadingComponent from '../components/utils/loading';
import { useClientInsurersById } from '../hooks/client-insurer-hook';

export const CLIENT_INSURER_BY_ID_CONTAINER_TEST_ID =
  'client-insurer-by-id-container';

const ClientInsurerByIdPage = (): JSX.Element => {
  const params = useParams<{ id: string }>();
  const clientInsurerId = parseInt(params.id || '0', 10);
  const { data, loading, error } = useClientInsurersById(clientInsurerId);

  if (!loading && error) {
    return (
      <HHAlert
        hhVariant="outlined"
        severity="error"
        children={
          <HHTypography hhVariant="body">
            There was an error loading the client insurer.
          </HHTypography>
        }
      ></HHAlert>
    );
  }

  if (!loading && !data) {
    return (
      <HHStack>
        <HHTypography hhVariant="body">
          Client insurer info not found
        </HHTypography>
      </HHStack>
    );
  }

  if (loading || !data) {
    return <LoadingComponent center />;
  }

  return (
    <HHStack
      direction="row"
      sx={{
        height: '100%',
        overflow: 'hidden',
      }}
      data-testid={CLIENT_INSURER_BY_ID_CONTAINER_TEST_ID}
    >
      <BillingLeftPanel data={data} clientInsurerId={clientInsurerId} />
      <BillingMainSection clientInsurerData={data} />
    </HHStack>
  );
};

export default ClientInsurerByIdPage;
